import Axios from '@/components/api/axios.js'

export default {
	/**
	 */
	addTransformerProtect(virtualDeviceId,nextCheckTime,expiredTime, success, failure) {
		Axios.post('/transformerProtect/addTransformerProtect.do', {
			virtualDeviceId,
			nextCheckTime,
			expiredTime
		}, success, failure)
	},
	
	/**
	 */
	getProtectCheckById(id, success, failure) {
		Axios.post('/transformerProtect/findByVirtualDeviceId.do', {
			id,
		}, success, failure)
	},
	deleteByVirtualDeviceId(virtualDeviceId, success, failure){
		Axios.post('/transformerProtect/deleteByVirtualDeviceId.do', {
			virtualDeviceId,
		}, success, failure)
	}
	// transformerProtect/deleteByVirtualDeviceId.do?virtualDeviceId=1
}